import URLConfig from '@Config/urls/url.config';
import { LinkItemProps } from '@Layouts/sidebar/AppSidebar';

const URL = URLConfig.TERMINAL_MANAGEMENT_SYSTEM.GAB_MANAGEMENT.TERMINAL_MENU;

const TerminalMenuLink: Array<LinkItemProps> = [
  {
    name: 'Point de vente',
    link: URL.SALES_POINT,
    level: 3,
  },
  {
    name: 'Terminal',
    link: URL.TERMINAL,
    level: 3,
  },
  {
    name: 'Log Event',
    link: URL.LOG_EVENT,
    level: 3,
  },
  {
    name: 'Carte Capturée',
    link: URL.CAPTURED_CARD,
    level: 3,
  },
  {
    name: 'Terminal Hors Service',
    link: URL.OUT_OF_SERVICE_TERMINAL,
    level: 3,
  },
  {
    name: 'Monitoring',
    link: URL.MONITORING,
    level: 3,
  },
  {
    name: 'Transaction GAB',
    link: URL.GAB_TRANSACTION,
    level: 3,
  },
];

export default TerminalMenuLink;
